// @flow
/* eslint-disable max-len, no-nested-ternary */

import React, { memo, useRef } from 'react';
import uuidv1 from 'uuid/v1';
import _ from 'lodash';
import VideoItem from './components/VideoItem';
import TagItem from './components/TagItem';
import Styles from './styles';

type Props = {
  size? : number,
  showSeasonButtons? : boolean,
  handlePrevSeasonButtonClick? : () => void,
  handleNextSeasonButtonClick? : () => void,
  prevSeasonButtonText? : string,
  nextSeasonButtonText? : string,
  listData : any,
  info? : {
    title : string,
    listType : string,
  },
};

export default memo(({
  size = 22,
  showSeasonButtons = false,
  handlePrevSeasonButtonClick,
  handleNextSeasonButtonClick,
  prevSeasonButtonText,
  nextSeasonButtonText,
  listData,
  info = null,
} : Props) => {
  const listElement = useRef();

  const handleClickListArrows = (direction : string) => {
    let listMargin = listElement.current.style.marginRight;
    const documentFontSize = parseFloat(getComputedStyle((document : any).documentElement).fontSize);
    const itemStyles = getComputedStyle(listElement.current.childNodes[1]);
    let itemSize = size;
    itemSize *= documentFontSize;
    itemSize = itemSize + parseFloat(itemStyles.marginRight) + parseFloat(itemStyles.marginLeft);
    listMargin = listMargin ? (direction === 'left') ? Math.abs(parseFloat(listMargin)) + itemSize : Math.abs(parseFloat(listMargin)) - itemSize : (direction === 'left') ? itemSize : 0;
    if (
      (
        direction === 'right'
        && (listMargin || listMargin === 0)
        && listMargin >= -1
      )
      || (
        direction === 'left'
        && (listMargin < ((listElement.current.childNodes.length - 3) * itemSize))
      )
    ) {
      listElement.current.style.marginRight = `-${Math.abs(listMargin)}px`;
    }
  };

  const listType = info ? _.get(info, 'listType') : listData.get('output_type');

  return (
    <Styles
      {...{
        className: `contentgroup${listType === 'taglist' ? ' tagList' : ' videoList'}`,
        rowid: listType === 'taglist' ? 'tag-list' : (listData.get('id') || uuidv1()),
        tagList: listType === 'taglist',
        showSeasonButtons,
      }}
    >
      <div className="titleWrapper">
        {
          (listData.get('link_text') === 'فیلم‌های نشان شده') &&
          <i className="fa fa-bookmark-o" />
        }
        <h3 className="listTitle">
          {(listType === 'taglist') ? 'دسته‌بندی‌ها' : info ? _.get(info, 'title') : listData.getIn(['title', 'text'])}
        </h3>
        {
          (showSeasonButtons && (prevSeasonButtonText || nextSeasonButtonText)) &&
          <div className="seasonsButtonsWrapper selectableRow preActiveRow">
            {
              prevSeasonButtonText &&
              <button
                className={`prevSeasonButton ${prevSeasonButtonText ? 'selectableItem' : ''}`}
                clickable="true"
                onClick={handlePrevSeasonButtonClick}
                disabled={!prevSeasonButtonText}
              >
                <i className="fa fa-arrow-right" />
                {prevSeasonButtonText}
              </button>
            }
            {
              nextSeasonButtonText &&
              <button
                className={`nextSeasonButton ${nextSeasonButtonText ? 'selectableItem' : ''}`}
                clickable="true"
                onClick={handleNextSeasonButtonClick}
                disabled={!nextSeasonButtonText}
              >
                {nextSeasonButtonText}
                <i className="fa fa-arrow-left" />
              </button>
            }
          </div>
        }
      </div>
      <div className="content">
        {
          (listType === 'video') ? listData.getIn(['video', 'data']) && listData.getIn(['video', 'data']).size > 0 && (
            <div className="horizontal-list selectableRow" ref={listElement}>
              {listData.getIn(['video', 'data'])
                .map((videoItem : any) => (
                  <VideoItem
                    key={videoItem.get('uid')}
                    {...{ data: videoItem.toJS(), size }}
                  />
                ))
              }
            </div>
          ) : (listType === 'taglist') &&
            listData.size > 0 && (
              <div className="horizontal-list selectableRow" ref={listElement}>
                {
                  listData.map((tagItem : any) => (
                    <TagItem
                      key={`tagitem-${tagItem.get('id')}-${tagItem.get('link').substr(1)}`}
                      {...{ data: tagItem.toJS(), size }}
                    />
                  ))
                }
              </div>
            )
        }
        <button className="arrow left" onClick={() => handleClickListArrows('left')}>
          <i className="fa fa-angle-double-left" />
        </button>
        <button className="arrow right" onClick={() => handleClickListArrows('right')}>
          <i className="fa fa-angle-double-right" />
        </button>
      </div>
    </Styles>
  );
});
